import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.dns');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-dns',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.dns/view.scss */
/* src/app/page.admin.dns/view.scss: no such file or directory */`],
})
export class PageAdminDnsComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = false;
    public list: any = [];
    public keyuptime: any = 0;
    public search: any = { text: "", page: 1, dump: 20 };
    public pagination: any = { end: -1, start: -1, current: 0 };

    // 편집 모달
    public showModal: boolean = false;
    public editMode: string = 'create'; // 'create' | 'edit'
    public editItem: any = { domain: '', zone_id: '', api_token: '', status: 'active', admin_only: false };

    // 토큰 표시 토글
    public visibleTokens: any = {};

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role("admin", "/");
        await this.load();
    }

    public async load(page: number = 1) {
        if (this.loading) return;
        this.loading = true;
        this.pagination.current = page;
        this.search.page = page;
        this.list = [];
        await this.service.render();

        const { code, data } = await wiz.call("search", this.search);
        if (code == 200) {
            let { rows, lastpage } = data;
            const startpage = Math.floor((page - 1) / 10) * 10 + 1;
            this.list = rows;
            this.pagination.start = startpage;
            this.pagination.end = lastpage;
        }

        this.loading = false;
        await this.service.render();
    }

    public async searchAction() {
        let keyuptime: any = new Date().getTime();
        this.keyuptime = keyuptime;
        await this.service.render(500);
        if (this.keyuptime != keyuptime) return;
        await this.load();
    }

    public openCreate() {
        this.editMode = 'create';
        this.editItem = { domain: '', zone_id: '', api_token: '', status: 'active', admin_only: false };
        this.showModal = true;
    }

    public openEdit(item: any) {
        this.editMode = 'edit';
        this.editItem = { ...item };
        this.showModal = true;
    }

    public closeModal() {
        this.showModal = false;
        this.editItem = { domain: '', zone_id: '', api_token: '', status: 'active', admin_only: false };
    }

    public async save() {
        if (!this.editItem.domain || !this.editItem.zone_id || !this.editItem.api_token) {
            await this.service.modal.error("도메인, Zone ID, API Token은 필수 입력입니다.", false, "확인");
            return;
        }

        this.service.status.show("loading");

        if (this.editMode === 'create') {
            const { code, data } = await wiz.call("create", this.editItem);
            this.service.status.hide("loading");
            if (code !== 200) {
                await this.service.modal.error(data.message || "생성 실패", false, "확인");
                return;
            }
        } else {
            const { code, data } = await wiz.call("update", this.editItem);
            this.service.status.hide("loading");
            if (code !== 200) {
                await this.service.modal.error(data.message || "수정 실패", false, "확인");
                return;
            }
        }

        this.closeModal();
        await this.load(this.pagination.current);
    }

    public async deleteItem(item: any) {
        if (!await this.service.modal.error(`'${item.domain}' DNS Zone을 삭제하시겠습니까?`, "취소", "삭제")) return;
        this.service.status.show("loading");
        const { code, data } = await wiz.call("delete", { id: item.id });
        this.service.status.hide("loading");
        if (code !== 200) {
            await this.service.modal.error(data.message || "삭제 실패", false, "확인");
            return;
        }
        await this.load(this.pagination.current);
    }

    public toggleToken(id: string) {
        this.visibleTokens[id] = !this.visibleTokens[id];
    }

    public maskValue(value: string) {
        if (!value) return '';
        if (value.length <= 8) return '••••••••';
        return value.substring(0, 4) + '••••••••' + value.substring(value.length - 4);
    }

    public statusBadgeClass(status: string) {
        if (status === 'active') {
            return 'inline-flex items-center rounded-full bg-green-50 px-2 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20';
        }
        return 'inline-flex items-center rounded-full bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-600 ring-1 ring-inset ring-gray-500/10';
    }

    public formatDate(dateStr: string) {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        const pad = (n: number) => n.toString().padStart(2, '0');
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    }
}

export default PageAdminDnsComponent;